(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-collection-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tf-collection-intro')) {
    customElements.define(
      'tf-collection-intro',
      class extends HTMLElement {
        connectedCallback() {
          this.copy = this.querySelector('[data-collection-intro-copy]');
          this.toggle = this.querySelector('[data-collection-intro-toggle]');

          if (!this.copy || !this.toggle) return;

          this.expanded = false;
          this.lastMeasuredWidth = 0;
          this.handleToggle = () => {
            this.expanded = !this.expanded;
            this.dataset.expanded = String(this.expanded);
            this.toggle.setAttribute('aria-expanded', String(this.expanded));
            this.toggle.textContent = this.expanded
              ? this.toggle.dataset.readLessLabel
              : this.toggle.dataset.readMoreLabel;
          };
          this.handleResize = (entries) => {
            const width = entries[0]?.contentRect.width ?? 0;
            if (Math.abs(width - this.lastMeasuredWidth) < 0.5) return;
            this.lastMeasuredWidth = width;
            this.scheduleMeasurement();
          };

          this.toggle.addEventListener('click', this.handleToggle);
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this);
          this.scheduleMeasurement();
        }

        disconnectedCallback() {
          this.toggle?.removeEventListener('click', this.handleToggle);
          this.resizeObserver?.disconnect();
          cancelAnimationFrame(this.measurementFrame);
        }

        scheduleMeasurement() {
          cancelAnimationFrame(this.measurementFrame);
          this.measurementFrame = requestAnimationFrame(() => this.measure());
        }

        measure() {
          const paragraphs = this.copy.querySelectorAll('p');
          const firstBlock = paragraphs[0];

          if (paragraphs.length < 2) {
            this.dataset.expandable = 'false';
            this.dataset.expanded = 'false';
            this.dataset.enhanced = 'true';
            this.toggle.hidden = true;
            return;
          }

          this.dataset.measuring = 'true';
          const copyRect = this.copy.getBoundingClientRect();
          const firstBlockRect = firstBlock.getBoundingClientRect();
          const firstBlockStyle = getComputedStyle(firstBlock);
          const firstBlockMargin = Number.parseFloat(
            firstBlockStyle.marginBlockEnd || firstBlockStyle.marginBottom || '0'
          );
          const collapsedHeight = Math.ceil(
            firstBlockRect.bottom - copyRect.top + firstBlockMargin
          );
          const expandedHeight = Math.ceil(this.copy.scrollHeight);
          const expandable = expandedHeight > collapsedHeight + 2;

          this.style.setProperty(
            '--tf-collection-intro-collapsed-height',
            `${collapsedHeight}px`
          );
          this.style.setProperty(
            '--tf-collection-intro-expanded-height',
            `${expandedHeight}px`
          );
          this.dataset.expandable = String(expandable);
          this.expanded = expandable && this.expanded;
          this.dataset.expanded = String(this.expanded);
          this.toggle.hidden = !expandable;
          this.toggle.setAttribute('aria-expanded', String(this.expanded));
          this.toggle.textContent = this.expanded
            ? this.toggle.dataset.readLessLabel
            : this.toggle.dataset.readMoreLabel;
          this.dataset.enhanced = 'true';
          delete this.dataset.measuring;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
